// extracted by mini-css-extract-plugin
export default {"loader_position":"measurementLoader_loader_position__v6O+b","loader_text":"measurementLoader_loader_text__-lo-r","loader_gif":"measurementLoader_loader_gif__iC+c5"};